$(document).on("ready", function() {
  $("input[type=hidden]").each(function() {
    var n = $(this).attr("name");
    if ($("[name=" + n + "]").length > 1) {
      $(this).remove();
    }
  });

  $("button.submit").on("click", function() {
    if ($(this).text() == "Back") {
      $("input, select").attr("required", false);
    }
  });

  $("#indie-help").on("click", function() {
    $("#independent-questions").toggleClass("expanded");
  });
});
